import React, { useState } from "react";
import RequestService from "../../services/request.service";

import './analitica.scss'


import { toast } from 'react-toastify'

import { useParams, Link } from 'react-router-dom'


import moment from 'moment'


import { Tabs, Tab, Form } from 'react-bootstrap'


// import HeatMap from '@uiw/react-heat-map';





		import {
		  Chart as ChartJS,
		  CategoryScale,
		  LinearScale,
		  BarElement,
		  Title,
		  Tooltip,
		  Legend,
		  Ticks,
		  ArcElement
		} from 'chart.js';

		// import { getRelativePosition } from 'chart.js/helpers';


		import { Bar } from 'react-chartjs-2';


		ChartJS.register(
		  CategoryScale,
		  LinearScale,
		  BarElement,
		  Title,
		  Tooltip,
		  Legend,
		  ArcElement
		);



const currencyFormat = (num) => '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')


const ReporteMensual = ( props ) => {



	// const { reporteData } = props

// const labels = [""];

// const [checked, setChecked] = useState(false);
const checked = false

const options = {
    scales: {
        x: {
            ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, ticks) {
                    return '$' + Ticks.formatters.numeric.apply(this, [value, index, ticks]);
                },
                color: (checked ?  'white' : 'black')
            },
            grid: {
              color: (checked ?  'white' : '#f2f2f2'),
              // borderColor: '#2b8f90',
              // lineWidth : 3
            }
        },
        y: {
            ticks: {
                color: (checked ?  'white' : 'black')
            },
            grid: {
              color: (checked ?  'white' : '#f2f2f2'),
              // borderColor: '#2b8f90',
              // lineWidth : 3
            }
        }
    },
    indexAxis: 'y' as const,
    elements: {
        bar: {
            borderWidth: 2,
        },
    },
    responsive: true,
    plugins: {
        legend: {
            display: false
        },
        title: {
            display: true,
            text: 'Estatus por Trámite por Día',
        },
    },


};


  const { reporteData } = props




const data = {
          labels : reporteData.reporteData.etiquetas,
          datasets: [
            {
              label: 'Monto',
              data: reporteData.reporteData.data,
              borderColor: '#247879',
              backgroundColor: '#36b3b4',
            },
          ],
        };






// const dona = {
//   labels: ['Red', 'Blue'],
//   datasets: [
//     {
//       label: '# of Votes',
//       data: [80,20],
//       backgroundColor: [
//         '#247879',
//         'rgba(255,255,255,0)',
//       ],
//       borderColor: [
//         '#36b3b4',
//         '#247879',
//       ],
//       borderWidth: 1,
//     },
//   ],
// };
//     const options_ = {
//       responsive: false,
//       maintainAspectRatio: false,

//         rotation: -90,
//         circumference: 180,

//   plugins: {
//    legend: {
//     display: false
//    },
//     title: {
//       display: true,
//       text: 'Meta del Mes',
//     },
//   },
//     }


   const [ verEstatus, setVerEstatus ] = useState<boolean>(true)


  const handleChange = async (evt:any) => {
    setVerEstatus (evt.target.checked);
  }




	return (
		<>

				
                  <div className="row">
                    <div className="col-5">

{
                        // <div className="row row-cols-3">
                        //   <div className="col">
                        //         <small><b>Total </b></small>
                        //         <h2>{reporteData.total_folios_mes}</h2>
                        //   </div>
                        //   <div className="col">
                        //         <small>En Gestión</small>
                        //         <h3>{reporteData.total_en_gestion}</h3>
                        //   </div>
                        //   <div className="col">
                        //         <small>Aceptados</small>
                        //         <h3>{reporteData.total_aceptados}</h3>
                        //   </div>
                        //   <div className="col">
                        //         <small>Sin Cobrar</small>
                        //         <h3>{reporteData.total_no_cobrado}</h3>
                        //   </div>
                        //   <div className="col">
                        //         <small>Finiquitado</small>
                        //         <h3>{reporteData.total_finiquitado}</h3>
                        //   </div>
                        //   <div className="col">
                        //         <small>Cancelados</small>
                        //         <h3>{reporteData.total_cancelados}</h3>
                        //   </div>
                        // </div>


                          
                          	// <Doughnut className="mb-4 mt-2" data={dona} width="420px" height="140px" options={options_}  />
                          }

                          {
                          	// JSON.stringify(reporteData.reporteData.etiquetas)
                          }

                          <Bar options={options} data={data} width="100%" height={300} />

                    </div>

                    <div className="col-7">
                        {
                          // JSON.stringify(reporteData.reporte_por_semanas)
                        }

                        <Form.Check type="switch" id="custom-switch2" label="Ver Estatus" onChange={handleChange} checked={verEstatus}  />

                        <table className="table table-striped table-sm" >
                          <tbody>

                            {

                              reporteData.reporte_por_semanas.map( (semana:any, i:number) =>

                                  <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                    <tr >
                                      <td style={{padding: '4px 2px', fontSize: '10px'}}>
                                        <small style={{color : (checked ?  'white' : 'black')}}>SEMANA {(i+1)}</small>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{padding:0}}>
                                        


                                            <table className="table table-sm" style={{color : (checked ?  'white' : 'black'), marginBottom: 0}}>
                                              <thead style={{fontSize:5}}>
                                                <tr>
                                                  <th scope="col">Día</th>
                                                  <th scope="col">Total</th>


                                                        {
                                                          verEstatus && (
                                                               <React.Fragment>
                                                                    {
                                                                      props.estatus.map((estatus:any,indice:number) =>

                                                                        <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                                            <th scope="col">{estatus.estatus}</th>
                                                                        </React.Fragment>

                                                                      )

                                                                    }
                                                               </React.Fragment>  
                                                            )

                                                        }


                                                        {
                                                          !verEstatus && (
                                                              <React.Fragment>
                                                                  <th scope="col">Monto Aseguramiento Final</th>
                                                                  <th scope="col">Monto Aseguramiento</th>
                                                              </React.Fragment>
                                                            )

                                                        }

                                                  
                                                </tr>
                                              </thead>
                                              <tbody>
                                              {
                                                semana.dias.map( (dia:any) =>

                                                      <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                        <th scope="row" className="text-right chiquitos" style={{width: 80}}>
                                                          <small>{dia.dia}</small>
                                                        </th>
                                                        <td className="text-right chiquitos" style={{width:44}}>
                                                          <small>{(dia.cantidad)}</small>
                                                        </td>



                                                        {
                                                          verEstatus && (
                                                               <React.Fragment>
                                                                  {
                                                                    dia.totales.map( total => (
                                                                            <td className="text-right chiquitos" style={{width:44}}>
                                                                              <small>{(total)}</small>
                                                                            </td>
                                                                        )
                                                                    )
                                                                  }
                                                               </React.Fragment>  
                                                            )

                                                        }


                                                        {
                                                          !verEstatus && (
                                                              <React.Fragment>
                                                                  <td className="text-right chiquitos" style={{width:144}}>
                                                                    <small>{currencyFormat(dia.monto_aseguramiento_final_total)}</small>
                                                                  </td>
                                                                  <td className="text-right chiquitos" style={{width:144}}>
                                                                    <small>{currencyFormat(dia.monto_aseguramiento_total)}</small>
                                                                  </td>
                                                              </React.Fragment>
                                                            )

                                                        }









                                                      </tr>

                                                  )
                                              }




                                                      <tr>


                                                        <th scope="row" className="text-right chiquitos">
                                                          <small><b>TOTAL</b></small>
                                                        </th>
                                                        <td className="text-right chiquitos">
                                                          <small>{(semana.total_folios)}</small>
                                                        </td>

                                                        {
                                                          verEstatus && (
                                                               <React.Fragment>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                               </React.Fragment>  
                                                            )

                                                        }


                                                        {
                                                          !verEstatus && (
                                                              <React.Fragment>
                                                                    <td className="text-right chiquitos">
                                                                      <small>{(semana.monto_aseguramiento_total)}</small>
                                                                    </td>
                                                                    <td className="text-right chiquitos">
                                                                      <small>{(semana.monto_aseguramiento_final_total)}</small>
                                                                    </td>
                                                              </React.Fragment>
                                                            )

                                                        }





                                                      </tr>


                                              </tbody>
                                            </table>



                                      </td>
                                    </tr>

                                  </React.Fragment>

                                )

                            }


                          </tbody>
                        </table>


                    </div>
                  </div>




		</>
	)

}


const AnaliticasPorSucursal = () =>{

  // let navigate = useNavigate();
  let { uuid_sucursal, year } = useParams();


  const MESES_ARRAY = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']
  const MESES_ARRAY_COMPLETO = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

	
const [ data_calendar, setDataCalendar ] : any = useState<any>([]);

	// const [ anio_reporte, setAnio ] = useState(parseInt(moment().format('YYYY')))
  const anio_reporte = parseInt(moment().format('YYYY'))

	const [ cargando_noticia, setCargando ] = useState(false)

	const [ data_analitica, setDataAnalitica ] = useState<any>({
		sucursal : {
		    nombre_sucursal : "",
		    uuid : "",
		    direccion : "",
		    colonia : "",
		    cp : "",
		    telefono : "",
		    email : "",
		    idestado : {},
		  },
		departamentos : [],
		anios_reporte : [],
		calendar : [],
    analitica_reporte_mensual : [],
		estatus : [{ id : 0, estatus : '' }],
	})


  const cargarMiReporte = async(anio:any)=>{
    try{
      setCargando(true)
      let response = await RequestService.getEndPoint('reporte/analiticos/'+uuid_sucursal+'/'+anio)
      setDataAnalitica(response.data)
      setDataCalendar(response.data.calendar)

      setCargando(false)

    }
    catch(e){
      setCargando(false)
      toast.error('Problemas')
    }
  }


  const [keykey, setKeyKey] = useState<any>(0);


  React.useEffect(  () => {
     cargarMiReporte( year )
    // console.log(new Date('2021-01-01'))
    // console.log(moment().toDate())
    setKey(0)
    setKeyKey(0)
  }, [year]);


  const [key, setKey] = useState<any>(0);


  // const [ startDate, setStartDate ] = useState<any>( new Date( anio_reporte + '-01-01') )
  const startDate = new Date( anio_reporte + '-01-01')
  // const [ endDate, setEndDate ] = useState<any>( new Date( (anio_reporte+1) + '-01-01') )
  const endDate = new Date( (anio_reporte+1) + '-01-01')


  // const [ startDate, setStartDate ] = useState<any>( new Date( anio_reporte + '-01-01') )
  // const [ endDate, setEndDate ] = useState<any>( new Date( (anio_reporte+1) + '-01-01') )


 //  const cambiarAnio = async (year:number) => {

 //  	setAnio(year)
 //  	setKey(0)
  	
 //  	await cargarMiReporte(year)

 //  	setStartDate( moment( year + '-01-01' ).toDate() )
	// setEndDate( moment( (year+1) + '-01-01' ).toDate() )	

 //  }


   const [ verEstatus, setVerEstatus ] = useState<boolean>(true)


  const handleChange = async (evt:any) => {
    setVerEstatus (evt.target.checked);
  }

	return (
		<>

			<div className="container-fluid">


				{


					(cargando_noticia) && (
							<>

								<div className="row justify-content-center">
									<div className="col-2">
										<div className="lds-ripple"><div></div><div></div></div>
									</div>
								</div>


							</>
					)

				}
				



				{


					(!cargando_noticia) && (

						<>

							<h5>Analíticas por Sucursal </h5>


                <div className="row">
                   <div className="col">

                      <h3>
                        {data_analitica.sucursal.nombre_sucursal} 
                        <small className="text-muted">{data_analitica.sucursal.uuid}</small>
                      </h3>
                      <p className="lead">{data_analitica.sucursal.direccion}, <b>{data_analitica.sucursal.colonia}</b> {data_analitica.sucursal.idestado.estado}</p>

                   </div>
                   <div className="col">

                      <ul className="list-group list-group-flush">
                        <li className="list-group-item"><i className="fa fa-mobile" /> {data_analitica.sucursal.telefono} </li>
                        <li className="list-group-item"><i className="fa fa-envelope" /> {data_analitica.sucursal.email} </li>
                      </ul>

                   </div>
                </div>

							{
								// JSON.stringify(data_analitica.sucursal)
							}






								<p className="nm mt-4">Resumen</p>
								<ul className="list-inline">
										{
											data_analitica.anios_reporte.map((anio:any)=>
                        <li className="list-inline-item" key={ Math.random().toString(36).substr(2, 9) }>
                          <Link className={ anio.year.toString() === year ? 'disabled-link' : '' } to={'/analiticas_sucursal/'+uuid_sucursal+'/'+anio.year}><small>{anio.year.toString()}</small></Link>
                        </li>
											)
										}	
								</ul>





							    <Tabs
							      id="controlled-tab-example"
							      activeKey={key}
							      onSelect={(k) => setKey(k)}
							      className="mb-3"
							    >

							      	{
							      		
							      		data_analitica.analitica_reporte_mensual.map( (data : any, i : number) =>

							      			<Tab key={i} eventKey={i}   title={ data.mes.toUpperCase() }>

                                            {
                                              // JSON.stringify(data)
                                            }


                                          <Tabs
                                            id="controlled-tab-reportemensual"
                                            activeKey={keykey}
                                            onSelect={(k) => setKeyKey(k)}
                                            
                                          >

                                              {
                                                
                                                data.analitica_departamento.map( (data_2 : any, indx : number) =>

                                                  <Tab key={indx} eventKey={indx} title={data_2.departamento.toUpperCase()}>

                                                      {
                                                        // JSON.stringify(data_2)
                                                      }

                                                            <>

                                                            <h3>REPORTE DEL MES DE {moment(data_2.fecha_reporte).format('MMMM').toUpperCase()}</h3>


                                                              <div className="row justify-content-center">
                                                                    <div className="col-sm-1">
                                                                        <div className="no info-tiles tiles-inverse has-footer">
                                                                          <div className="tiles-heading">
                                                                            <div className="pull-left" style={{color:'black'}}>Total</div>
                                                                        </div>
                                                                        <div className="tiles-body" style={{height:'100px', paddingTop:'30px'}}>
                                                                            <div className="text-center" style={{color:'black'}}>{data_2.total_folios_mes}</div>
                                                                        </div>
                                                                      </div>
                                                                    </div>

                                                                    {
                                                                      data_analitica.estatus.map((estatus:any,indice:number) =>

                                                                        <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                                            <div className="col-sm-1">
                                                                                <div className="no info-tiles tiles-inverse has-footer">
                                                                                  <div className={ 'estatus_'+ estatus.id + ' tiles-heading'}>
                                                                                    <div className="pull-left">{estatus.estatus}</div>
                                                                                </div>
                                                                                <div className={ 'estatus_'+ estatus.id + ' tiles-body'} style={{height:'100px', paddingTop:'30px'}}>
                                                                                    <div className="text-center">{data_2.totales[indice]}</div>
                                                                                </div>
                                                                            </div>
                                                                            </div>
                                                                        </React.Fragment>

                                                                      )

                                                                    }
                                                              </div>

                                                          <div className="row">
                                                            <div className="col-7">
                                                              {

                                                                <ReporteMensual reporteData={data_2} estatus={data_analitica.estatus}  />
                                                              }
                                                            </div>
                                                            <div className="col-5">

                                                            <Form.Check type="switch" id="custom-switch" label="Ver Estatus" onChange={handleChange} checked={verEstatus}  />

                                                                <table className="table">
                                                                  <thead>
                                                                    <tr>
                                                                      <th scope="col">Gerentes</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                  {
                                                                    data_2.por_gerente.map( gerente =>

                                                                      <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                        <td>
                                                                          <p className="nm"><b>{gerente.nombres}</b> <small>{gerente.paterno} {gerente.materno}</small></p>
                                                                          


                                                                            <p style={{fontSize:9}} className="nm"><b><small>ASESORES</small></b></p>


                                                                            {
                                                                              gerente.asesores.length === 0 && (
                                                                                <React.Fragment>
                                                                                  <small style={{fontSize:9}}>Sin registro de actividad <i className="fa fa-warning" /></small>
                                                                                </React.Fragment>
                                                                              )
                                                                            }

                                                                            {
                                                                              gerente.asesores.length > 0 && (
                                                                                <React.Fragment>
                                                                                  
                                                                                      <table className="table table-sm" style={{ marginBottom: 0}}>
                                                                                        <thead style={{fontSize:5}}>
                                                                                          <tr>
                                                                                            <th scope="col">Día</th>
                                                                                            <th scope="col">Total</th>








                                                                                              {
                                                                                                verEstatus && (
                                                                                                    <React.Fragment>

                                                                                                            {
                                                                                                              data_analitica.estatus.map((estatus:any,indice:number) =>

                                                                                                                <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                                                                                    <th className={'estatus_'+ estatus.id} scope="col">{estatus.estatus}</th>
                                                                                                                </React.Fragment>

                                                                                                              )

                                                                                                            }

                                                                                                    </React.Fragment>  
                                                                                                  )

                                                                                              }

                                                                                              {
                                                                                                !verEstatus && (
                                                                                                      <React.Fragment>
                                                                                                          <th scope="col">Monto Aseguramiento Final</th>
                                                                                                          <th scope="col">Monto Aseguramiento</th>
                                                                                                      </React.Fragment>
                                                                                                  )

                                                                                              }

                                                                                            
                                                                                          </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                        {
                                                                                          gerente.asesores.map( asesor =>

                                                                                                <tr key={ Math.random().toString(36).substr(2, 9) }>


                                                                                                  <th scope="row" className="text-right chiquitos" style={{width: 150, fontSize:8}}>
                                                                                                    <small><b>{asesor.nombres}</b></small> {asesor.paterno} {asesor.materno}
                                                                                                  </th>
                                                                                                  <td className="text-right chiquitos" style={{width:44}}>
                                                                                                    <small>{(asesor.tots)}</small>
                                                                                                  </td>


                                                                                                    {
                                                                                                      verEstatus && (
                                                                                                           <React.Fragment>
                                                                                                                {
                                                                                                                  asesor.totales.map( total =>

                                                                                                                    <td key={ Math.random().toString(36).substr(2, 9) } className="text-right chiquitos" style={{width:44}}>{total}</td>
                                                                                                                  )
                                                                                                                }
                                                                                                           </React.Fragment>  
                                                                                                        )

                                                                                                    }


                                                                                                    {
                                                                                                      !verEstatus && (
                                                                                                          <React.Fragment>
                                                                                                            <td className="text-right chiquitos" style={{width:100}}>
                                                                                                                <small>{currencyFormat(Math.round(asesor.monto_aseguramiento_final_total))}</small>
                                                                                                            </td>
                                                                                                            <td className="text-right chiquitos" style={{width:100}}>
                                                                                                                <small>{currencyFormat(Math.round(asesor.monto_aseguramiento_total))}</small>
                                                                                                            </td>

                                                                                                          </React.Fragment>
                                                                                                        )

                                                                                                    }


                                                                                                    </tr>




                                                                                            )
                                                                                        }


                                                                                        </tbody>
                                                                                      </table>

                                                                                </React.Fragment>
                                                                              )
                                                                            }



                                                                        </td>
                                                                      </tr>

                                                                    )
                                                                  }

                                                                  </tbody>
                                                                </table>


                                                                  {
                                                                    data_2.asesores_sin_gerente.length > 0 && (
                                                                      <h6>Asesores</h6>
                                                                    )
                                                                  }
                                                                  

                                                                  <ol className="list-group list-group-numbered">

                                                                    {
                                                                      data_2.asesores_sin_gerente.map( asesores =>


                                                                          <li key={ Math.random().toString(36).substr(2, 9) } className="list-group-item d-flex justify-content-between align-items-start">
                                                                            <div className="ms-2 me-auto">
                                                                              <p><b>{asesores.nombres}</b> <small className="chiquito">{asesores.paterno} {asesores.materno}</small></p>
                                                                              
                                                                            </div>
                                                                            <span className="badge bg-primary rounded-pill">{asesores.tots}</span>
                                                                          </li>

                                                                      )
                                                                    }

                                                                  </ol>



                                                            </div>
                                                          </div>
                                                            </>

                                                  </Tab>

                                                )
                                              }

                                          </Tabs>







							      			</Tab>

							      		)
							      	}

							    </Tabs>




							    <hr />







						</>
)
					

				}







			</div>


		</>
	)
}


export default AnaliticasPorSucursal